import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv2310GetResultModel, Inv2310GetResultSchema } from './get.schema'

export async function fetchInv2310(id: number): Promise<Inv2310GetResultModel> {
  const response = await axios.get<Inv2310GetResultModel>(
    `/api/warehouse/inv2310/${id}`
  )
  return Inv2310GetResultSchema.parse(response.data)
}

export const getInv2310ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv2310', id],
    queryFn: () => fetchInv2310(id),
  })
